import { cx } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import styles from './DeviceWrapper.module.scss';

interface DeviceWrapperProps extends ComponentPropsWithoutRef<'div'> {
  readonly children: ReactNode;
}

const DeviceWrapper: React.FC<DeviceWrapperProps> = ({
  children,
  className,
}: DeviceWrapperProps): JSX.Element => {
  return (
    <div
      className={cx(
        styles.MarvelDevice,
        styles['MarvelDevice--iPhoneX'],
        className,
      )}
    >
      <div className={styles.notch}>
        <div className={styles.camera} />
        <div className={styles.speaker} />
      </div>
      <div className={styles['top-bar']} />
      <div className={styles['bottom-bar']} />
      <div className={styles.overflow}>
        <div className={cx(styles['shadow--tr'], styles.shadow)} />
        <div className={cx(styles['shadow--tl'], styles.shadow)} />
        <div className={cx(styles['shadow--br'], styles.shadow)} />
        <div className={cx(styles['shadow--bl'], styles.shadow)} />
      </div>
      <div className={styles['inner-shadow']} />
      <div className={styles.screen}>{children}</div>
    </div>
  );
};

export default DeviceWrapper;
